export default {
  //消息接口
  //查询消息列表
  getSysMessagePeopleList: '/api/sysMessagePeople/getSysMessagePeopleList',
  //待办接口
  //获取有待办的日期
  getTodoList: '/api/todoList/getTodoList',
  //添加待办接口
  addTodoList: '/api/todoList/addTodoList',
  //获取当天待办
  getTodayTodo: '/api/todoList/getTodayTodo',
  //文件库目录
  getFileFoldersTree: '/api/fileDirectory/getFileDirectoryListTree',
  //消息已读
  readSysMessage: '/api/sysMessagePeople/readSysMessage',
  //获取公司短信接收手机号列表
  getCompanySmsPhoneList: '/api/companySmsPhone/getCompanySmsPhoneList',
  //批量绑定手机号到公司
  bindSmsPhones: '/api/companySmsPhone/bindSmsPhones',
  //批量解绑手机号
  unbindSmsPhones: '/api/companySmsPhone/unbindSmsPhones',
  //获取命令列表
  getCommandList: '/api/command/getCommandList',
};
